import { render, staticRenderFns } from "./SectionTabs.vue?vue&type=template&id=67516e14&scoped=true"
import script from "./SectionTabs.vue?vue&type=script&lang=js"
export * from "./SectionTabs.vue?vue&type=script&lang=js"
import style0 from "./SectionTabs.vue?vue&type=style&index=0&id=67516e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67516e14",
  null
  
)

export default component.exports